import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgxConditionSelectorFilter} from "./ngx-condition-selector-filter";
import {ConditionOperator, Filter} from "../../ngx-types";

@Component({
  selector: 'ngx-filter-conditions-selector',
  templateUrl: './conditions-selector.component.html',
  styleUrls: ['./conditions-selector.component.scss']
})
export class ConditionsSelectorComponent extends NgxConditionSelectorFilter implements OnInit {
  @Input() conditions: { key: ConditionOperator, label: string }[] = [];
  @Input() filter: Filter;
  label: string;
  options: any;
  value: any;
  valueChange = new EventEmitter<any>();


  ngOnInit(): void {
  }

  onChangeValue(ev: Event): void {
    this.value = ev.target['value'];
    this.valueChange.emit(this.value)
  }

}
